import data from '../codigosMexico.json'

export const obtenerEstados = () => {

    let estados = data.map(item => item.state);

    let set  = new Set(estados);

    return [...set].sort()

}